var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoEnable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.57031,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.5703V18.0703C27.5 17.5203 27.05 17.0703 26.5 17.0703H14.5C13.95 17.0703 13.5 17.5203 13.5 18.0703V28.0703C13.5 28.6203 13.95 29.0703 14.5 29.0703H26.5C27.05 29.0703 27.5 28.6203 27.5 28.0703V24.5703L31.5 28.5703V17.5703L27.5 21.5703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoEnable);
export default __webpack_public_path__ + "static/media/videoEnable.62e9e52ef2d3005e5f8c9cdbd270cc1f.svg";
export { ForwardRef as ReactComponent };